/**
 * Component for action buttons (add lesson, generate content, etc.)
 */

import React from 'react'
import { Button, Alert, Icon } from 'antd'
import { useTranslation } from 'react-i18next'

const ActionButtons = ({
  contentSuccessInAllSections,
  isGeneratingContent,
  isFromKnowledgeCenter,
  isSavingContent,
  isGeneratingCourse,
  progressStatus,
  checkError,
  onShowNewLessonModal,
  onSaveContent,
  onToggleDocumentModal,
  onOpenTemplateModal,
  onGenerateContent
}) => {
  const { t } = useTranslation()

  if (contentSuccessInAllSections) {
    return (
      <div className="ai-course__table-of-content__create_lesson">
        {!isGeneratingContent && (
          <>
            <Button
              className="ai-course__table-of-content__add-lesson shl-secondary-btn"
              onClick={onShowNewLessonModal}
            >
              {t('v3:ai_add_lesson')}
            </Button>
          </>
        )}
        {!isFromKnowledgeCenter && (
          <Button
            type="primary"
            shape="round"
            onClick={onSaveContent}
            loading={isSavingContent}
            ghost
          >
            {t('v3:ai_save_later')}
          </Button>
        )}

        <Button
          icon="file-word"
          type="green"
          shape="round"
          onClick={onToggleDocumentModal}
          loading={isGeneratingCourse}
        >
          {t('v3:ai_download_word_doc')}
        </Button>

        {!isFromKnowledgeCenter && (
          <Button
            type="primary"
            shape="round"
            onClick={onOpenTemplateModal}
            loading={isGeneratingCourse}
          >
            {t('v5:proceed_to_template_selection')}
            <Icon type="right" />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className="ai-course__table-of-content__create_lesson__button-with-notes">
      <div className="create-lesson-button-with-btn">
        {!isGeneratingContent && (
          <>
            <Button
              className="ai-course__table-of-content__add-lesson shl-secondary-btn"
              onClick={onShowNewLessonModal}
            >
              {t('v3:ai_add_lesson')}
            </Button>
          </>
        )}
        <Button
          type="green"
          shape="round"
          onClick={onGenerateContent}
          loading={isGeneratingContent}
          style={{ marginLeft: '10px' }}
        >
          {t('v3:ai_generate_course_content')}
        </Button>
      </div>

      {checkError() && (
        <Alert
          message={`${progressStatus.subTopicsWithError} ${t('v3:ai_out_of')} ${
            progressStatus.totalSubtopics
          } ${t('v3:ai_subtopic_failed_content')}`}
          type="error"
          banner
        />
      )}
    </div>
  )
}

export default ActionButtons
